import React, { useState } from 'react';
import { UserManagement } from '../modules/auth/components/UserManagement';

export const multiStepContext = React.createContext();

const UserRegistryContext = () => {
	const [currentStep, setStep] = useState(1);
	const [userData, setUserData] = useState([]);
	const [finalData, setFinalData] = useState([]);
	const [data, setData] = useState([]);
	const [loadedData, setLoadedData] =
		useState(false); /*Used to know if the information has been loaded once (edit mode)*/
	const [loading, setLoading] =useState(false);

	const submitData = () => {
		setFinalData((finalData) => [...finalData, userData]);
		setUserData('');
	};

	return (
		<div>
			<multiStepContext.Provider
				value={{
					currentStep,
					setStep,
					userData,
					setUserData,
					finalData,
					setFinalData,
					submitData,
					data,
					setData,
					loadedData,
					setLoadedData,
					loading,
					setLoading
				}}
			>
				<UserManagement />
			</multiStepContext.Provider>
		</div>
	);
};

export default UserRegistryContext;
